import { render, staticRenderFns } from "./modalCongrats.vue?vue&type=template&id=d9d3409a&scoped=true&"
import script from "./modalCongrats.vue?vue&type=script&lang=js&"
export * from "./modalCongrats.vue?vue&type=script&lang=js&"
import style0 from "./modalCongrats.vue?vue&type=style&index=0&id=d9d3409a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9d3409a",
  null
  
)

export default component.exports